import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@state-mgmt/store';
import { TrialGroupUser } from '@mytypes/trial';

export const useGetGrower = () => {
  const { trialGrowers } = useSelector((state: RootState) => state.trial);
  return useCallback((memberId: string): TrialGroupUser | undefined => trialGrowers.find(member => member.user_id === memberId), [trialGrowers]);
};
